import React from 'react';
import { useGuitarMatch } from '../context/GuitarMatchContext';
import LogoGSCInline from './LogoGSCInline';
import { PRICING } from '../services/config';

export const SubscriptionOverlay: React.FC = () => {
    const { setShowSubscriptionOffer, setIsPremium, lang, setActiveOverlay } = useGuitarMatch();

    const handleSubscribe = (planName: string) => {
        setIsPremium(true);
        localStorage.setItem('gsc_is_premium', 'true');
        setShowSubscriptionOffer(false);
        
        const msg = lang === 'fr' 
            ? `Félicitations ! Votre Pass Studio ${planName} est actif. Toutes les analyses Neural sont débloquées.` 
            : `Congrats! Your ${planName} Studio Pass is active. All Neural analytics are unlocked.`;
        
        alert(msg);
    };

    return (
        <div className="fixed inset-0 z-[20000] flex items-center justify-center p-4 md:p-10 animate-fade-in">
            <div className="absolute inset-0 bg-black/95 backdrop-blur-3xl" onClick={() => setShowSubscriptionOffer(false)}></div>
            
            <div className="relative w-full max-w-5xl flex flex-col gap-10">
                <div className="text-center space-y-4">
                    <LogoGSCInline size={80} className="text-smart-gold mx-auto" />
                    <h2 className="text-5xl md:text-7xl font-black text-white italic uppercase tracking-tighter leading-none">
                        Pass <span className="text-smart-accent">Studio Master</span>
                    </h2>
                    <p className="text-slate-400 text-lg font-medium italic">Accédez à l'audit haute-fidélité pour tous vos morceaux du Club.</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* PLAN SOLO */}
                    <div className="relative p-10 rounded-[56px] border-2 border-white/10 bg-white/5 flex flex-col gap-8 transition-all hover:border-white/20">
                        <div className="space-y-1">
                            <h3 className="text-2xl font-black text-white uppercase italic tracking-tighter">Add-on Solo Studio</h3>
                            <p className="text-slate-500 text-sm font-bold italic">Pour le membre GSC indépendant.</p>
                        </div>
                        <div className="flex items-baseline gap-2">
                            <span className="text-7xl font-black text-white italic">{PRICING.SOLO_MONTHLY}</span>
                            <span className="text-xl font-bold text-slate-500">€/mois</span>
                        </div>
                        <div className="flex-1 space-y-4 text-sm font-bold text-slate-300">
                            <div className="flex items-center gap-3"><span className="text-emerald-500">✓</span> Analyses Neural Illimitées</div>
                            <div className="flex items-center gap-3"><span className="text-emerald-500">✓</span> Vision Lab (Correction Geste)</div>
                            <div className="flex items-center gap-3"><span className="text-emerald-500">✓</span> Synchronisation Cloud avec le Club</div>
                        </div>
                        <button onClick={() => handleSubscribe('Solo Studio')} className="w-full py-6 rounded-full bg-white text-black font-black uppercase tracking-[0.2em] text-xs hover:bg-smart-accent hover:text-white transition-all">DÉBLOQUER LE STUDIO ⚡</button>
                    </div>

                    {/* PLAN INSTITUTION (B2B) */}
                    <div className="relative p-10 rounded-[56px] border-2 border-smart-gold bg-smart-gold/5 flex flex-col gap-8 shadow-[0_0_50px_rgba(218,144,0,0.2)]">
                        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-smart-gold text-black px-6 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest shadow-2xl">INCLUS PACK ÉCOLE</div>
                        <div className="space-y-1">
                            <h3 className="text-2xl font-black text-white uppercase italic tracking-tighter text-smart-gold">Pass Institutionnel</h3>
                            <p className="text-slate-500 text-sm font-bold italic">Lié à ton conservatoire partenaire.</p>
                        </div>
                        <div className="flex items-baseline gap-2">
                            <span className="text-7xl font-black text-white italic">{PRICING.INSTITUTION_STUDENT}</span>
                            <span className="text-xl font-bold text-slate-500">€/mois</span>
                        </div>
                        <div className="flex-1 space-y-4 text-sm font-bold text-slate-300">
                            <div className="flex items-center gap-3"><span className="text-smart-gold">✓</span> Tout le Plan Solo Studio</div>
                            <div className="flex items-center gap-3"><span className="text-smart-gold">✓</span> Dashboard de progression Prof</div>
                            <div className="flex items-center gap-3"><span className="text-smart-gold">✓</span> Accès illimité via Code École</div>
                        </div>
                        <button onClick={() => handleSubscribe('Institutionnel')} className="w-full py-6 rounded-full bg-smart-gold text-black font-black uppercase tracking-[0.2em] text-xs hover:bg-white transition-all shadow-xl">ACTIVER CODE ÉCOLE 🎓</button>
                    </div>
                </div>

                <button onClick={() => setShowSubscriptionOffer(false)} className="mx-auto text-[10px] font-black text-slate-600 uppercase tracking-widest hover:text-white transition-colors">Retour au Studio (Mode Découverte)</button>
            </div>
        </div>
    );
};